<template>
    <div class="avatar-list">
        <div
            v-for="(url, index) in defaultImgs"
            :key="index"
            :class="{ 'avatar-item--select': currentValue == url }"
            @click="onChangeDefaultAvatar(url)"
            class="avatar-item"
        >
            <img :src="url">
        </div>
        <p-uploader
            ref="uploader"
            v-show="!hasUploadAvatar"
            :url="uploadUrl + '?type=upload'"
            @start="onUploadAvatarStart"
            @complete="onUploadAvatarComplete"
            class="avatar-item avatar-item--upload"
            size-limit="2MB"
            type-limit="*.jpg;*.jpeg;*.png;*.bmp"
        >
            <svg
                class="avatar-item--upload__icon"
                width="75"
                height="75"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 75 75"
                style="enable-background:new 0 0 75 75;"
                xml:space="preserve"
            >
                <polygon points="41,35 41,0 35,0 35,35 0,35 0,41 35,41 35,75 41,75 41,41 75,41 75,35 " />
            </svg>
        </p-uploader>
        <v-spinner
            v-if="isUploading"
            status="default"
        />
        <div
            v-if="hasUploadAvatar"
            :class="{ 'avatar-item--select': uploadValue == currentValue }"
            @click="onChangeCustomAvatar"
            class="avatar-item avatar-item--custom"
        >
            <img :src="uploadValue">

            <div
                @click.stop="onDeleteUploadAvatar"
                class="btn-edit"
            >
                <v-icon name="edit" />
            </div>
        </div>
        <p-cropper
            :panel-open="cropperPanelOpen"
            :url="cropperUrl"
            :ratio="1"
            :keep-ratio="true"
            :value="cropperValue"
            :cropping="isCropping"
            @confirm="onConfirmCroppImage"
            @cancel="onCancelCroppImage"
        />
    </div>
</template>

<script>
import PUploader from 'src/pages/srv/wpa2/detail/components/uploader/index';
import PCropper from 'src/pages/srv/wpa2/detail/components/cropper';

export default {
    name: 'AvatarSelector',

    components: {
        PUploader,
        PCropper,
    },

    model: {
        prop: 'value',
        event: 'input',
    },

    props: {
        value: {
            type: String,
            default: '',
        },
        avatarRoot: {
            type: String,
            default: '',
        },
        wpaInfo: {
            type: Object,
            default() {
                return {};
            },
        },
        uploadUrl: {
            type: String,
            default: '',
        },
    },

    data() {
        const defaultImgs = [1, 2, 3, 4, 5].map(key => `https:${this.avatarRoot}wxkf-${key}.png`);
        return {
            defaultImgs,
            currentValue: this.value,
            uploadValue: defaultImgs.indexOf(this.value) !== -1 ? '' : this.value,
            hasUploadAvatar: defaultImgs.indexOf(this.value) === -1 && this.value,
            cropperPanelOpen: false,
            cropperUrl: '',
            cropperValue: {},

            isUploading: false,
            isCropping: false,
        };
    },

    watch: {
        value(nextValue) {
            this.currentValue = nextValue;
        },
    },

    created() {
        if (this.value === '') {
            this.onChangeDefaultAvatar(this.defaultImgs[0]);
        }
    },

    methods: {
        onChangeDefaultAvatar(url) {
            this.currentValue = url;
            this.$emit('input', url);
        },

        onChangeCustomAvatar() {
            this.currentValue = this.uploadValue;
            this.$emit('input', this.currentValue);
        },

        onUploadAvatarStart() {
            this.isUploading = true;
        },

        onUploadAvatarComplete(rowRet) {
            let ret = rowRet;
            switch (ret.status) {
            case 0:
                ret = ret.data || {};
                if (ret.data && +ret.data.r === 0) {
                    this.cropperPanelOpen = true;
                    this.cropperUrl = ret.data.data.url;

                    const cropSize = [
                        '',
                        { cropWidth: 80, cropHeight: 80 },
                        { cropWidth: 85, cropHeight: 85 },
                        { cropWidth: 150, cropHeight: 200 },
                    ];
                    this.cropperValue = cropSize[this.wpaInfo.avatarType] || { cropWidth: 80, cropHeight: 80 };
                    this.cropperValue = { ...this.cropperValue, cropX: 0, cropY: 0, rotate: 0 };
                } else {
                    this.$message.error((ret.data && ret.data.msg) || '上传图片出错了');
                }
                break;
            case 1:
                this.$message.error('只能上传JPG/PNG/BMP类型的图片');
                break;
            case 2:
                this.$message.error('图片限定2M内');
                break;
            default:
                this.$message.error('上传图片出错了');
            }

            this.isUploading = false;
        },

        onDeleteUploadAvatar() {
            this.$refs.uploader.defaultClick();
            // this.hasUploadAvatar = false;
            // this.uploadValue = '';

            // if (this.wpaInfo.avatarType) {
            //     this.onChangeDefaultAvatar(1);
            // } else {
            //     this.currentValue = '';
            //     this.isDefaultAvatar = 0;

            //     this.$emit('input', {
            //         avatar: this.currentValue,
            //     });
            // }
        },

        onConfirmCroppImage(data) {
            this.isCropping = true;

            this.$ajax
                .post(`${this.uploadUrl}?type=crop`, {
                    src: data.src,
                    width: data.width,
                    height: data.height,
                    cropWidth: data.cropWidth,
                    cropHeight: data.cropHeight,
                    originX: parseInt(data.cropX / data.scale, 10),
                    originY: parseInt(data.cropY / data.scale, 10),
                    originWidth: parseInt(data.cropWidth / data.scale, 10),
                    originHeight: parseInt(data.cropHeight / data.scale, 10),
                })
                .then(
                    (cropData) => {
                        if (cropData && +cropData.r === 0) {
                            this.hasUploadAvatar = true;
                            this.currentValue = cropData.data.url;
                            this.uploadValue = cropData.data.url;

                            this.$emit('input', this.currentValue);
                        } else {
                            this.$message.error('图片裁切失败');
                        }
                        this.__resetCroppProperty();
                    },
                    (error) => {
                        this.$message.error(error.msg || '图片裁切失败');
                        this.__resetCroppProperty();
                    }
                );
        },

        onCancelCroppImage() {
            if (this.isCropping) return;
            this.__resetCroppProperty();
        },

        __resetCroppProperty() {
            this.cropperPanelOpen = false;
            this.isCropping = false;
        },
    },
};
</script>

<style lang="less">
// @import '../../../styles/sprite.less';

@white-color: #fff;
@link-font-color: #0067ed;
@border-bold-color: #dadee7;
@help-font-color: #a8abb3;

.avatar-item {
    float: left;
    margin-right: 15px;
    width: 50px;
    height: 50px;
    cursor: pointer;

    img {
        width: 50px;
        height: 50px;
        border-radius: 5px;
    }

    &--select {
        width: 50px;
        height: 50px;
        box-shadow: 0 0 0 2px @link-font-color;
        border-radius: 5px;

        img {
            width: 50px;
            height: 50px;
        }
    }

    &--upload {
        width: 50px;
        height: 50px;
        margin-right: -1px;
        font-size: 0;
        color: #c5ccdb;
        border: 2px dashed #e1e6f0;
        border-radius: 4px;
        line-height: 0;

        .v-uploader__list,
        .v-uploader__tip {
            display: none;
        }

        &:hover {
            width: 50px;
            height: 50px;
            color: #a9abb2;
            border: 2px dashed #a9abb2;
        }

        &__icon {
            margin: 10px;
            width: 25px;
            height: 25px;
            fill: currentColor;
        }
    }

    &--custom {
        position: relative;
        margin-right: -1px;
        .btn-edit {
            position: absolute;
            top: -11px;
            right: -11px;
            color: #fff;
            width: 26px;
            height: 26px;
            border-radius: 50%;
            background-color: #000;
            display: none;
            z-index: 1;
            .v-icon {
                position: absolute;
                top: 5px;
                left: 5px;
                width: 15px;
                height: 15px;
            }
        }

        &:hover {
            .btn-edit {
                display: block;
            }
        }
    }
}

.avatar-list {
    padding-top: 12px;
}
</style>
